import React from 'react'

const RecentEvents: React.FC = () => {
    return (
        <section className="page-section bg-light" id="steampunk">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase">Recent Events</h2>
                </div>
                <div className="row my-5">
                    <div className="col">
                        <h3 className="text-center">Thank you for coming out and supporting us at our Juneteenth Steam Punk Tea Party!</h3>
                        <div className="ratio ratio-16x9">
                            <video
                                className="w-100 h-100"
                                controls
                                playsInline
                                preload="metadata"
                                title="Highlights from the Juneteenth Steampunk Tea Party"
                            >
                                <source src="./video/steampunk-recap.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
                <div className="row my-5">
                    <div className="col">
                        <h3 className="text-center">Thank you for coming out and supporting us at our Black Fae Day!</h3>
                        <div className="ratio ratio-16x9">
                            <video
                                className="w-100 h-100"
                                controls
                                playsInline
                                preload="metadata"
                                title="Highlights from Black Fae Day"
                            >
                                <source src="./video/black-fae-day-commercial.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>

                {/* <div className="row my-5">
                    <div className="col">
                        <h3 className="text-center">Our First Nap Night! (Click below to read more)</h3>
                        <a href="https://www.ketv.com/article/omaha-nonprofit-hosts-nap-night/46974075">
                            <img src="./img/napnight.png" width="100%" alt="Nap Night event" />
                        </a>
                    </div>
                </div> */}
            </div>
        </section>
    )
}

export default RecentEvents
